import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

interface NotificationsState {
  notificationsEnabled: boolean;
}

const initialState: NotificationsState = {
  notificationsEnabled: localStorage.getItem('oppy_notifications_enabled') !== 'false'
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    disableNotifications: (state) => {
      state.notificationsEnabled = false;
      localStorage.setItem('oppy_notifications_enabled', 'false');
    },
    enableNotifications: (state) => {
      state.notificationsEnabled = true;
      localStorage.setItem('oppy_notifications_enabled', 'true');
    }
  }
});

export const { disableNotifications, enableNotifications } = notificationsSlice.actions;

export const selectNotificationsEnabled = (state: RootState) => state.notifications.notificationsEnabled;

export default notificationsSlice.reducer; 
